import React from "react";
import { Link } from "react-router-dom";

const CheckoutSteps = ({ shipping, confirmOrder, payment}) => {
  return (
    <div className="flex justify-center mt-5">
      <div
        className={`relative ${shipping ? "text-blue-500" : "text-gray-400"}`}
      >
        <Link to={shipping ? "/shipping" : "#!"} className="px-2 py-1">
          {shipping ? (
            <>
              <div className="absolute inset-0  -ml-1 z-10"></div>
              <div className="bg-blue-500 py-1 px-3 rounded-full text-white shadow-md">
                Shipping
              </div>
            </>
          ) : (
            <div className="py-1 px-3 rounded-full shadow-md">Shipping</div>
          )}
        </Link>
      </div>

      <div
        className={`relative ${payment ? "text-green-500" : "text-gray-400"}`}
      >
        <Link to={payment ? "/payment_method" : "#!"} className="px-2 py-1">
          {payment ? (
            <>
              <div className="absolute inset-0   -ml-1 z-10"></div>
              <div className="bg-blue-500 py-1 px-3 rounded-full text-white shadow-md">
                Payment
              </div>
            </>
          ) : (
            <div className="py-1 px-3 rounded-full shadow-md">Payment</div>
          )}
        </Link>
      </div>

      <div
        className={`relative ${
          confirmOrder ? "text-green-500" : "text-gray-400"
        }`}
      >
        <Link to={confirmOrder ? "/confirm_order" : "#!"} className="px-2 py-1">
          {confirmOrder ? (
            <>
              <div className="absolute inset-0  -ml-1 z-10"></div>
              <div className="bg-blue-500 py-1 px-3 rounded-full text-white shadow-md">
                ConfirmOrder
              </div>
            </>
          ) : (
            <div className="py-1 px-3 rounded-full shadow-md">ConfirmOrder</div>
          )}
        </Link>
      </div>
    </div>
  );
};

export default CheckoutSteps;
